// extracted by mini-css-extract-plugin
export var text = "_by-0";